export default "__VITE_ASSET__BUCgwlWs__"